'use client';

import React from 'react';
import Select, { SingleValue, OptionsOrGroups, Props } from 'react-select';
import { cn } from '@/app/_lib/utils';

interface SelectProps extends Props {
  options: OptionsOrGroups<any, any>;
  value: SingleValue<any>;
  variant: 'default' | 'primary';
  onChange: (value: SingleValue<any>) => void;
  [key: string]: any;
}

const SelectInput: React.FC<SelectProps> = ({
  options,
  value,
  onChange,
  isDisabled,
  classNames,
  variant,
  ...rest
}) => {
  return (
    <Select
      value={value}
      onChange={onChange}
      options={options}
      isSearchable={true}
      isDisabled={isDisabled}
      classNames={{
        control: () =>
          cn(
            {
              'rounded-[3px] bg-white border border-grey4 border-solid shadow-input px-4 py-3 font-hanken text-sm leading-7':
                variant === 'default',
            },
            {
              '!rounded-[8px] !border-2 !border-purple7 my-4 pl-6 pr-4 py-3 font-hanken text-sm leading-7 !bg-transparent min-w-[140px]':
                variant === 'primary',
            },
            {
              '!border-grey4 !text-greyPurple !min-w-0 !pr-6': isDisabled,
            }
          ),
        input: () => '!p-0',
        dropdownIndicator: () =>
          cn(
            { '!hidden': isDisabled },
            { '!text-purple7': variant === 'primary' }
          ),
        valueContainer: () => '!p-0',
        indicatorSeparator: () => '!hidden',
        singleValue: () =>
          cn(
            { 'font-semibold !text-purple7': variant === 'primary' },
            { '!text-purple-dark': isDisabled }
          ),
        option: (props) =>
          cn('!p-4 font-hanken text-sm leading-7', {
            '!bg-purple1': props.isFocused,
            '!bg-purple3': props.isSelected,
          }),
        ...classNames,
      }}
      {...rest}
    />
  );
};

export default SelectInput;
